import SaleService from '@/api/SaleService'

// initial state
const state = {
  sales: [],
  sale: null,
  nextSoCode: null,
}

// getters
const getters = {
  getSales: state => state.sales,
  getSale: state => state.sale,
  getNextSoCode: state => state.nextSoCode,
  getSaleStatus: (state) => (sale, $t, mixin) => {
    let debtAmount = mixin.getDebtSaleAmount(sale)
    let foundTaskInvoice = false
    let foundTaskDelivered = false
    let isDoneDelivered = true
    let isDoneInvoiced = true

    // end this line if this po has rejected
    if (sale.status == 'rejected') {
      return {
        message: $t('status.so.rejected'),
        status: 'rejected',
      }
    }
    // end this line if this po is padding
    if (sale.status == 'padding') {
      return {
        message: $t('status.so.padding'),
        status: 'padding',
      }
    }

    // set value
    if (sale.reference.goodsissues.length == 0) {
      isDoneDelivered = false
    } else {
      foundTaskDelivered = true
      for (let i in sale.reference.goodsissues) {
        if (sale.reference.goodsissues[i].status != 'done') {
          isDoneDelivered = false
        }
      }
    }

    if (sale.reference.invoices.length == 0) {
      isDoneInvoiced = false
    } else {
      foundTaskInvoice = true
      for (let i in sale.reference.invoices) {
        let inv = sale.reference.invoices[i]
        if (inv.reference.payments.length == 0) {
          isDoneInvoiced = false
        } else {
          for (let j in inv.reference.payments) {
            let pe = inv.reference.payments[j]
            if (pe.status != 'paid') {
              isDoneInvoiced = false
            }
          }
        }
      }
      if (debtAmount > 0) {
        isDoneInvoiced = false
      }
    }
    // set value ended

    // not found any tasks
    if (!foundTaskInvoice && !foundTaskDelivered || (foundTaskDelivered && isDoneDelivered) && !foundTaskInvoice) {
      return {
        message: $t('status.so.toinvoice'),
        status: 'uncompleted',
      }
    }

    // found tasks invoice and delivery and not done any
    if (foundTaskInvoice && foundTaskDelivered) {
      if (!isDoneInvoiced && !isDoneDelivered) {
        return {
          message: $t('status.so.todeliveryandpay'),
          status: 'uncompleted',
        }
      }
    }

    // not found tasks invoice and found tasks delivery
    if (!foundTaskInvoice && (foundTaskDelivered && !isDoneDelivered)) {
      return {
        message: $t('status.so.todeliveryandinvoice'),
        status: 'uncompleted',
      }
    }

    // done invoices and not done delivery
    if ((foundTaskInvoice && isDoneInvoiced) && (foundTaskDelivered && !isDoneDelivered)) {
      return {
        message: $t('status.so.todelivery'),
        status: 'uncompleted',
      }
    }

    // not done invoice
    if (foundTaskInvoice && !isDoneInvoiced) {
      return {
        message: $t('status.so.topay'),
        status: 'uncompleted',
      }
    }

    return {
      message: $t('status.so.completed'),
      status: 'completed',
    }
  },
}

// mutations
const mutations = {
  setSales(state, data) {
    state.sales = data
  },
  setSale(state, data) {
    state.sale = data
  },
  setNextSoCode(state, data) {
    state.nextSoCode = data
  },
  updateSaleStatus(state, data) {
    if (state.sale) {
      if (state.sale.so_id == data.so_id) {
        state.sale.status = data.status
      }
    }
    if (state.sales.length > 0) {
      state.sales.map((p, idx) => {
        if (p.so_id == data.so_id) {
          return p.status = data.status
        }
      })
    }
  },
}

// actions
const actions = {
  async getSales({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getSales') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getSales')

      let response = await SaleService.getAll(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getSales')

      result = response.data

      if (result.success) {
        commit('setSales', result.data)
        this.dispatch('setPagination', result.meta)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearSales({ commit }) {
    commit('setSales', [])
  },
  async getSale({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getSale') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getSale')

      let response = await SaleService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getSale')

      result = response.data

      if (result.success) {
        if (result.data.length > 0) {
          commit('setSale', result.data[0])
        } else {
          // not found data
          this.dispatch('Error', 'Not found data')
        }
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearSale({ commit }) {
    commit('setSale', null)
  },
  async insertSale({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      const response = await SaleService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        // success
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getNextSoCode({ commit }) {
    var result = null

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getNextSoCode') >= 0) return

    try {
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getNextSoCode')

      let response = await SaleService.getLatestCode()

      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getNextSoCode')

      result = response.data

      if (result.success) {
        commit('setNextSoCode', result.data.next)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteSale({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await SaleService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateSale({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await SaleService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateSaleStatus({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await SaleService.updateStatus(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        commit('updateSaleStatus', data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Sale.js